var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-select-base", {
        attrs: {
          model: _vm.selected,
          items: _vm.items,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          clearable: _vm.clearable,
          dense: _vm.dense,
          itemText: _vm.itemText,
          disabled: _vm.disabled,
          autoComplete: _vm.autoComplete,
          showAdd: _vm.showAdd,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          onShowForm: function ($event) {
            _vm.showForm = true
          },
          change: function ($event) {
            return _vm.$emit("change", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }